import React, { useEffect, useState } from 'react';
import {
	Dialog,
	IconButton,
	DialogTitle,
	DialogContent,
	makeStyles,
	DialogContentText,
	Box,
	Grid,
	Divider,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
// import HeadlineText from './HeadlineText';
// import AddUserForm from '../../forms/AddUserForm';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { toggleFlightModal } from '../../reducers/UiReducer';
import logodialog from '../../assets/images/logodialog.png';
import LoginForm from './LoginForm';
import spice from '../../assets/images/spice.gif';
import TitleText from './TitleText';
import BodyText from './BodyText';
const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: 'transparent',
		backdropFilter: 'blur(2px)',
		'&MuiDialog-paperScrollPaper': {
			borderRadius: 5,
		},
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		// top: theme.spacing(3),
		padding: 0,
		[theme.breakpoints.down('xs')]: {
			top: theme.spacing(2.5),
		},
		color: theme.palette.grey[500],
	},
}));

const FlightDetailModal = () => {
	const classes = useStyles();
	const theme = useTheme();
	const dispatch = useDispatch();
	const {
		search,
		onewayflightdata,
		fareRule,
		fareRuleEtrav,
		onewayflightdataEtrav,
	} = useSelector((state) => state.home);
	const { flightId, etravflightFare } = useSelector((state) => state.ui);
	const [flight, setFlight] = useState(true);
	const [baggage, setBaggage] = useState(false);
	const [fare, setFare] = useState(false);
	const [fareDetail, setDetail] = useState(false);
	const { createflight } = useSelector((state) => state.ui);
	const matches = useMediaQuery(theme.breakpoints.down('xs'));
	const handleClose = () => {
		dispatch(toggleFlightModal(false));
	};
	function timeConvert(n) {
		var num = n;
		var hours = num / 60;
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return rhours + ' hr and ' + rminutes + ' min.';
	}
	let appnt = [];
	let etrav = [];
	if (onewayflightdata) {
		console.log('first');
		onewayflightdata.result &&
			onewayflightdata.result.Response &&
			onewayflightdata.result.Response.Results &&
			onewayflightdata.result.Response.Results.length > 0 &&
			onewayflightdata.result.Response.Results[0].map((app, index) => {
				if (app.ResultIndex === flightId) {
					appnt.push({
						...app,
					});
				}
			});
	}
	if (onewayflightdataEtrav) {
		onewayflightdataEtrav.result &&
			onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
			onewayflightdataEtrav.result.TripDetails[0].Flights.map((item, index) => {
				if (item.Flight_Id === flightId) {
					etrav.push({
						...item,
					});
				}
			});
	}
	// useEffect(() => {
	// 	console.log('Hello Hi');
	// }, [createflight]);
	console.log(flightId);
	console.log('APPNT', appnt);
	console.log('Etrav', etrav);
	// let tab =
	// 	!fareRule === null
	// 		? `${
	// 				fareRule &&
	// 				fareRule.result &&
	// 				fareRule.result.Response &&
	// 				fareRule.result.Response.FareRules[0].FareRuleDetail
	// 		  }`
	// 		: '<h1>hello</h1>';
	// document.getElementById('show').innerHTML = tab;
	return (
		<Dialog
			PaperProps={{
				style: { borderRadius: 20, maxWidth: 1500 },
			}}
			TransitionProps={{
				style: { backgroundColor: 'transparent' },
			}}
			onClose={handleClose}
			aria-labelledby='customized-dialog-title'
			className={classes.root}
			open={createflight}>
			<DialogTitle id='customized-dialog-title' onClose={handleClose}>
				<Box textAlign='center'>
					<Box display='flex' justifyContent='space-evenly'>
						<IconButton
							aria-label='close'
							className={classes.closeButton}
							onClick={handleClose}>
							<CloseIcon style={{ color: '#0035F0' }} fontSize='large' />
						</IconButton>
					</Box>
				</Box>
			</DialogTitle>
			<DialogContent>
				<DialogContentText id='alert-dialog-description'>
					<Box display='flex'>
						<Box
							onClick={() => {
								setFlight(true);
								setBaggage(false);
								setFare(false);
								setDetail(false);
							}}
							style={{
								display: 'block',
								cursor: 'pointer',
								padding: '8px 15px',
								margin: '0 5px 0 0',
								background: flight ? 'white' : '#f8f7f3',
								borderBottom: flight
									? '2px solid #39c9bb'
									: '2px solid #dfd39d',
							}}>
							<TitleText three>Flight Details</TitleText>
						</Box>
						<Box
							onClick={() => {
								setFlight(false);
								setBaggage(false);
								setFare(false);
								setDetail(true);
							}}
							style={{
								display: 'block',
								cursor: 'pointer',
								padding: '8px 15px',
								margin: '0 5px 0 0',
								background: fareDetail ? 'white' : '#f8f7f3',
								borderBottom: fareDetail
									? '2px solid #39c9bb'
									: '2px solid #dfd39d',
							}}>
							<TitleText three>Fare Details</TitleText>
						</Box>
						<Box
							onClick={() => {
								setFlight(false);
								setBaggage(true);
								setFare(false);
								setDetail(false);
							}}
							style={{
								display: 'block',
								cursor: 'pointer',
								padding: '8px 15px',
								margin: '0 5px 0 0',
								background: baggage ? 'white' : '#f8f7f3',
								borderBottom: baggage
									? '2px solid #39c9bb'
									: '2px solid #dfd39d',
							}}>
							<TitleText three>Baggage Information</TitleText>
						</Box>
						<Box
							onClick={() => {
								setFlight(false);
								setBaggage(false);
								setFare(true);
								setDetail(false);
							}}
							style={{
								display: 'block',
								cursor: 'pointer',
								padding: '8px 15px',
								margin: '0 5px 0 0',
								background: fare ? 'white' : '#f8f7f3',
								borderBottom: fare ? '2px solid #39c9bb' : '2px solid #dfd39d',
							}}>
							<TitleText three>Fare Rule</TitleText>
						</Box>
					</Box>
					{flight && appnt && appnt.length === 1 && (
						<>
							{appnt[0] &&
								appnt[0].Segments[0].map((item) => {
									return (
										<>
											<Grid
												container
												style={{
													border: '1px solid #eee',
													marginRight: 330,
													marginTop: 10,
													alignItems: 'center',
												}}>
												<Grid
													item
													xs={3}
													style={{
														backgroundColor: '#f6f5f5',
														padding: 20,
													}}>
													<Box alignItems='center'>
														<img
															src={`https://nitish.musafirbazar.com/static/media/${item.Airline.AirlineCode}.gif`}
															width='50px'
															height='25px'></img>
														<Box alignItems='center' ml={'5px'}>
															<TitleText three>
																{item.Airline.AirlineName}
															</TitleText>
															<BodyText three>
																{item.Airline.AirlineCode}-
																{item.Airline.FlightNumber}
															</BodyText>
														</Box>
													</Box>
												</Grid>
												<Grid item xs={3}>
													<Box alignItems='center' style={{ marginLeft: 5 }}>
														<Box display='flex' alignItems='center'>
															<TitleText
																three
																textStyle={{ textTransform: 'uppercase' }}>
																{item.Origin.Airport.CityName}
																{''}
															</TitleText>
															<TitleText three>
																({item.Origin.Airport.AirportCode})
															</TitleText>
														</Box>
														<Box display='flex' alignItems='center'>
															<TitleText three>
																{`${new Date(
																	item.Origin.DepTime.substr(0, 10)
																).toLocaleString('en-us', {
																	weekday: 'short',
																})} ,  ${new Date(
																	item.Origin.DepTime.substr(0, 10)
																).getDate()} ${new Date(
																	item.Origin.DepTime.substr(0, 10)
																).toLocaleString('en-us', {
																	month: 'short',
																})}`}
																{', '}
															</TitleText>
															<TitleText three>
																{item.Origin.DepTime.substr(11, 5)}
															</TitleText>
														</Box>
													</Box>
												</Grid>
												<Grid item xs={3}>
													<Box alignItems='center'>
														<TitleText three>
															{timeConvert(item.Duration)}
														</TitleText>
													</Box>
												</Grid>
												<Grid item xs={3}>
													<Box alignItems='center'>
														<Box display='flex' alignItems='center'>
															<TitleText
																three
																textStyle={{ textTransform: 'uppercase' }}>
																{item.Destination.Airport.CityName}
															</TitleText>
															<TitleText three>
																({item.Destination.Airport.AirportCode})
															</TitleText>
														</Box>
														<Box display='flex' alignItems='center'>
															<TitleText three>
																{`${new Date(
																	item.Destination.ArrTime.substr(0, 10)
																).toLocaleString('en-us', {
																	weekday: 'short',
																})} ,  ${new Date(
																	item.Destination.ArrTime.substr(0, 10)
																).getDate()} ${new Date(
																	item.Destination.ArrTime.substr(0, 10)
																).toLocaleString('en-us', {
																	month: 'short',
																})}`}
															</TitleText>
															<TitleText three>
																{', '}
																{item.Destination.ArrTime.substr(11, 5)}
															</TitleText>
														</Box>
													</Box>
												</Grid>
											</Grid>
										</>
									);
								})}
						</>
					)}
					{flight && etrav && etrav.length === 1 && (
						<>
							{etrav[0] &&
								etrav[0].Segments.map((item) => {
									return (
										<>
											<Grid
												container
												style={{
													border: '1px solid #eee',
													marginRight: 330,
													marginTop: 10,
													alignItems: 'center',
												}}>
												<Grid
													item
													xs={3}
													style={{
														backgroundColor: '#f6f5f5',
														padding: 20,
													}}>
													<Box alignItems='center'>
														<img
															src={`https://nitish.musafirbazar.com/static/media/${item.Airline_Code}.gif`}
															width='50px'
															height='25px'></img>
														<Box alignItems='center' ml={'5px'}>
															<TitleText three>{item.Airline_Name}</TitleText>
															<BodyText three>
																{item.Airline_Code}-{item.Flight_Number}
															</BodyText>
														</Box>
													</Box>
												</Grid>
												<Grid item xs={3}>
													<Box alignItems='center' style={{ marginLeft: 5 }}>
														<Box display='flex' alignItems='center'>
															<TitleText
																three
																textStyle={{ textTransform: 'uppercase' }}>
																{item.Origin_City}
																{''}
															</TitleText>
															<TitleText three>({item.Origin})</TitleText>
														</Box>
														<Box display='flex' alignItems='center'>
															<TitleText three>
																{`${new Date(
																	item.Departure_DateTime.substr(0, 10)
																).toLocaleString('en-us', {
																	weekday: 'short',
																})} ,  ${new Date(
																	item.Departure_DateTime.substr(0, 10)
																).getDate()} ${new Date(
																	item.Departure_DateTime.substr(0, 10)
																).toLocaleString('en-us', {
																	month: 'short',
																})}`}
																{', '}
															</TitleText>
															<TitleText three>
																{item.Departure_DateTime.substr(11, 5)}
															</TitleText>
														</Box>
													</Box>
												</Grid>
												<Grid item xs={3}>
													<Box alignItems='center'>
														<TitleText three>
															{/* {timeConvert(item.Duration)} */}
														</TitleText>
													</Box>
												</Grid>
												<Grid item xs={3}>
													<Box alignItems='center'>
														<Box display='flex' alignItems='center'>
															<TitleText
																three
																textStyle={{ textTransform: 'uppercase' }}>
																{item.Destination_City}
															</TitleText>
															<TitleText three>({item.Destination})</TitleText>
														</Box>
														<Box display='flex' alignItems='center'>
															<TitleText three>
																{`${new Date(
																	item.Arrival_DateTime.substr(0, 10)
																).toLocaleString('en-us', {
																	weekday: 'short',
																})} ,  ${new Date(
																	item.Arrival_DateTime.substr(0, 10)
																).getDate()} ${new Date(
																	item.Arrival_DateTime.substr(0, 10)
																).toLocaleString('en-us', {
																	month: 'short',
																})}`}
															</TitleText>
															<TitleText three>
																{', '}
																{item.Arrival_DateTime.substr(11, 5)}
															</TitleText>
														</Box>
													</Box>
												</Grid>
											</Grid>
										</>
									);
								})}
						</>
					)}
					{baggage && (
						<>
							<Box
								mt={'20px'}
								alignItems='center'
								justifyContent='space-between'
								display='flex'>
								<Box ml={'20px'}>
									<TitleText
										textStyle={{
											fontFamily: 'Josefin Sans, sans-serif',
										}}>
										Flight Sector
									</TitleText>
								</Box>
								<Box ml={'150px'}>
									<TitleText
										textStyle={{
											fontFamily: 'Josefin Sans, sans-serif',
										}}>
										Check in Baggage
									</TitleText>
								</Box>
								<Box ml={'150px'}>
									<TitleText
										textStyle={{
											fontFamily: 'Josefin Sans, sans-serif',
										}}>
										Cabin Baggage
									</TitleText>
								</Box>
							</Box>
							<Divider style={{ marginTop: 20 }} />
							{appnt[0] &&
								appnt[0].Segments[0].map((item) => {
									return (
										<>
											<Box
												mt={'20px'}
												alignItems='center'
												justifyContent='space-between'
												display='flex'>
												<Box ml={'20px'}>
													<BodyText>
														{item.Origin.Airport.AirportCode}-
														{item.Destination.Airport.AirportCode} (
														{item.Airline.AirlineCode}-
														{item.Airline.FlightNumber})
													</BodyText>
												</Box>
												<Box ml={'150px'}>
													<BodyText> {item.Baggage} (ADULT)</BodyText>
												</Box>
												<Box ml={'150px'}>
													<BodyText>{item.CabinBaggage} (ADULT)</BodyText>
												</Box>
											</Box>
											<Divider style={{ marginTop: 20 }} />
										</>
									);
								})}
						</>
					)}
					{etravflightFare && fareDetail && etrav && etrav.length === 1 && (
						<>
							<Box>
								<Box style={{ marginTop: 20, padding: 24 }}>
									{/* <div
										dangerouslySetInnerHTML={{
											__html:
												fareRuleEtrav &&
												fareRuleEtrav.result &&
												fareRuleEtrav.result.FareRules[0].FareRuleDesc,
										}}
									/> */}
									{/* <Box
										display='flex'
										justifyContent='space-around'
										style={{ textAlign: 'center' }}></Box> */}
									<Box display='flex' justifyContent='space-between'>
										<Box>
											<h6 style={{ fontWeight: 'bold' }}>Fare Details</h6>
											<Box display='flex'>
												<h6>Basic_Amount:</h6>
												<h6 style={{ marginLeft: 10 }}>
													{etravflightFare.FareDetails[0].Currency_Code}
												</h6>
												<h6 style={{ marginLeft: 5 }}>
													{Math.round(
														etravflightFare.FareDetails[0].Basic_Amount
													)}
												</h6>
											</Box>
											<Box display='flex'>
												<h6>AirportTax_Amount:</h6>
												<h6 style={{ marginLeft: 10 }}>
													{etravflightFare.FareDetails[0].Currency_Code}
												</h6>
												<h6 style={{ marginLeft: 5 }}>
													{Math.round(
														etravflightFare.FareDetails[0].AirportTax_Amount
													)}
												</h6>
											</Box>
											<Box display='flex'>
												<h6>Service_Fee_Amount:</h6>
												<h6 style={{ marginLeft: 10 }}>
													{etravflightFare.FareDetails[0].Currency_Code}
												</h6>
												<h6 style={{ marginLeft: 5 }}>
													{Math.round(
														etravflightFare.FareDetails[0].Service_Fee_Amount
													)}
												</h6>
											</Box>
											<Box display='flex'>
												<h6>TDS:</h6>
												<h6 style={{ marginLeft: 10 }}>
													{etravflightFare.FareDetails[0].Currency_Code}
												</h6>
												<h6 style={{ marginLeft: 5 }}>
													{Math.round(etravflightFare.FareDetails[0].TDS)}
												</h6>
											</Box>
											<Box display='flex'>
												<h6>Total_Amount:</h6>
												<h6 style={{ marginLeft: 10 }}>
													{etravflightFare.FareDetails[0].Currency_Code}
												</h6>
												<h6 style={{ marginLeft: 10 }}>
													{Number(
														Math.round(
															etravflightFare.FareDetails[0].Basic_Amount
														)
													) +
														Number(
															Math.round(
																etravflightFare.FareDetails[0].AirportTax_Amount
															)
														) -
														Number(
															Math.round(
																etravflightFare.FareDetails[0].Net_Commission
															)
														) +
														Number(
															Math.round(
																etravflightFare.FareDetails[0]
																	.Service_Fee_Amount
															)
														) +
														Number(
															Math.round(etravflightFare.FareDetails[0].TDS)
														)}
												</h6>
											</Box>
										</Box>
										<Box style={{ marginLeft: 50 }}>
											{/* <h6 style={{ fontWeight: 'bold' }}>
												Cancellation Charges
											</h6>
											<Box display='flex'>
												<h6>Domestic Change Penality:</h6>
												<h6 style={{ marginLeft: 10 }}>INR</h6>
												<h6 style={{ marginLeft: 10 }}>110</h6>
											</Box>
											<Box display='flex'>
												<h6>International Change Penality:</h6>
												<h6 style={{ marginLeft: 10 }}>INR</h6>
												<h6 style={{ marginLeft: 10 }}>330</h6>
											</Box> */}
										</Box>
									</Box>

									{/* {fareRule === null ? (
												<>
													<p>
														{fareRuleEtrav &&
															fareRuleEtrav.result &&
															fareRuleEtrav.result.FareRules[0].FareRuleDesc}
													</p>
												</>
											) : (
												<>
													<div
														dangerouslySetInnerHTML={{
															__html:
																fareRule.result.Response.FareRules[0]
																	.FareRuleDetail,
														}}
													/>
													<h6>Second</h6>
													<div
														dangerouslySetInnerHTML={{
															__html:
																fareRule.result.Response.FareRules[1]
																	.FareRuleDetail,
														}}
													/>
												</>
											)} */}
								</Box>
							</Box>
						</>
					)}
					{fareDetail && appnt && appnt.length === 1 && (
						<>
							<Box>
								<Box style={{ marginTop: 20, padding: 24 }}>
									{/* <div
										dangerouslySetInnerHTML={{
											__html:
												fareRule.result.Response.FareRules[0].FareRuleDetail,
										}}
									/>
									<h6>Second</h6>
									<div
										dangerouslySetInnerHTML={{
											__html:
												fareRule.result.Response.FareRules[1].FareRuleDetail,
										}}
									/> */}

									<Box display='flex' justifyContent='space-between'>
										<Box>
											<h6 style={{ fontWeight: 'bold' }}>Fare Details</h6>
											<Box display='flex'>
												<h6>Base Fare:</h6>
												<h6 style={{ marginLeft: 10 }}>
													{appnt[0].Fare.Currency}
												</h6>
												<h6 style={{ marginLeft: 5 }}>
													{Math.round(appnt[0].Fare.BaseFare)}
												</h6>
											</Box>
											<Box display='flex'>
												<h6>Service Tax:</h6>
												<h6 style={{ marginLeft: 10 }}>
													{appnt[0].Fare.Currency}
												</h6>
												<h6 style={{ marginLeft: 5 }}>
													{Math.round(appnt[0].Fare.Tax)}
												</h6>
											</Box>
											<Box display='flex'>
												<h6>Discount:</h6>
												<h6 style={{ marginLeft: 10 }}>
													{appnt[0].Fare.Currency}
												</h6>
												<h6 style={{ marginLeft: 5 }}>
													{Math.round(appnt[0].Fare.Discount)}
												</h6>
											</Box>
											<Box display='flex'>
												<h6>Grand Total:</h6>
												<h6 style={{ marginLeft: 10 }}>
													{appnt[0].Fare.Currency}
												</h6>
												<h6 style={{ marginLeft: 10 }}>
													{Math.round(appnt[0].Fare.OfferedFare)}
												</h6>
											</Box>
										</Box>
										<Box style={{ marginLeft: 50 }}>
											{/* <h6 style={{ fontWeight: 'bold' }}>
												Cancellation Charges
											</h6>
											<Box display='flex'>
												<h6>Domestic Change Penality:</h6>
												<h6 style={{ marginLeft: 10 }}>
													{appnt[0].Fare.Currency}
												</h6>
												<h6 style={{ marginLeft: 10 }}>110</h6>
											</Box>
											<Box display='flex'>
												<h6>International Change Penality:</h6>
												<h6 style={{ marginLeft: 10 }}>
													{appnt[0].Fare.Currency}
												</h6>
												<h6 style={{ marginLeft: 10 }}>330</h6>
											</Box> */}
											{/* Cancellation Charges Domestic Change Penality : INR 110
										International Change Penality : INR 300 */}
										</Box>
									</Box>
								</Box>
							</Box>
						</>
					)}
					{fare && etrav && etrav.length === 1 && (
						<>
							<Box>
								<Box style={{ marginTop: 20, padding: 24 }}>
									<div
										dangerouslySetInnerHTML={{
											__html:
												fareRuleEtrav &&
												fareRuleEtrav.result &&
												fareRuleEtrav.result.FareRules[0].FareRuleDesc,
										}}
									/>
									{/* <Box
										display='flex'
										justifyContent='space-around'
										style={{ textAlign: 'center' }}></Box> */}

									{/* {fareRule === null ? (
												<>
													<p>
														{fareRuleEtrav &&
															fareRuleEtrav.result &&
															fareRuleEtrav.result.FareRules[0].FareRuleDesc}
													</p>
												</>
											) : (
												<>
													<div
														dangerouslySetInnerHTML={{
															__html:
																fareRule.result.Response.FareRules[0]
																	.FareRuleDetail,
														}}
													/>
													<h6>Second</h6>
													<div
														dangerouslySetInnerHTML={{
															__html:
																fareRule.result.Response.FareRules[1]
																	.FareRuleDetail,
														}}
													/>
												</>
											)} */}
								</Box>
							</Box>
						</>
					)}
					{fare &&
						fareRule &&
						fareRule.result &&
						fareRule.result.Response &&
						fareRule.result.Response.FareRules[0] && (
							<>
								<Box>
									<Box style={{ marginTop: 20, padding: 24 }}>
										<div
											style={{ fontSize: 11 }}
											dangerouslySetInnerHTML={{
												__html:
													fareRule &&
													fareRule.result &&
													fareRule.result.Response &&
													fareRule.result.Response.FareRules[0].FareRuleDetail,
											}}
										/>
										{/* <h6>Second</h6>
										<div
											dangerouslySetInnerHTML={{
												__html:
													fareRule.result.Response.FareRules[1].FareRuleDetail,
											}}
										/> */}
									</Box>
								</Box>
							</>
						)}
				</DialogContentText>
			</DialogContent>
		</Dialog>
	);
};

export default FlightDetailModal;
